import { Popup } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import { Content } from './components';
import { qaPrefix } from './XeroContactAddressSearchPopup.constants';
import { XeroContactAddressSearchPopupProps } from './XeroContactAddressSearchPopup.types';

const qa = bemFactory.qa(qaPrefix);

export const XeroContactAddressSearchPopup: FC<XeroContactAddressSearchPopupProps> = memo((props) => {
    const { open, onClose } = props;

    return (
        <Popup open={open} onClose={onClose} size='small' qa={qa()}>
            <Content />
        </Popup>
    );
});

XeroContactAddressSearchPopup.displayName = 'XeroContactAddressSearchPopup';
